export enum Constants {
    valid= "VALID",
    invalid= "INVALID",
    noChange= "noChange",
    update= "update",
    W2_Q1 = "w2-q1",
    W2_Q2 = "w2-q2",
    table= "table",
    dropdown= "dropdown-multiple"

}

